import type { ChatMessage } from "@/api/models";

/** Parse citations from a tool result without treating Code Interpreter output as citations. */
export const parseCitationsFromToolMessage = (message: ChatMessage) => {
  if (message?.role !== "tool" || message.tool_type === "code_interpreter") {
    return [];
  }

  try {
    let toolMessage;
    try {
      toolMessage = JSON.parse(message.content);
    } catch {
      toolMessage = message.content;
    }

    if (toolMessage?.citations && Array.isArray(toolMessage.citations)) {
      return toolMessage.citations;
    }
    if (toolMessage?.length > 0) {
      return toolMessage;
    }
  } catch {
    // Tool output is not guaranteed to be JSON.
  }

  return [];
};

/** Return tool messages produced after the user prompt for an assistant turn. */
export const getToolMessagesForAssistantTurn = (
  messages: ChatMessage[],
  assistantIndex: number,
): ChatMessage[] => {
  let userIndex = -1;
  for (let index = assistantIndex - 1; index >= 0; index -= 1) {
    if (messages[index]?.role === "user") {
      userIndex = index;
      break;
    }
  }

  return messages
    .slice(userIndex + 1, assistantIndex)
    .filter((candidate) => candidate.role === "tool");
};
